// Code generated by "typescripter -type=DatasetLocStatus -linecomment -output=../../portal/src/enums/datasetlocstatusenum.ts"; DO NOT EDIT.

export enum DatasetLocStatusEnum {
  DatasetLocStatusDelivered = 'delivered',
  DatasetLocStatusScanning = 'scanning',
  DatasetLocStatusRecalled = 'recalled',
}
